import { createBrowserRouter } from 'react-router-dom';
import App from '../App';
import { Body } from '@/components/Body';
import { Smer } from '@/components/Smer';
import { SmerInner } from '@/components/Smer/SmerInner';
import { Auth } from '@/components/Auth';
import { Profile } from '@/components/Body/Profile';
import { Dashboard } from '@/components/Body/Dashboard';
import { NewClient } from '@/components/Body/NewClient';
import { Client } from '@/components/Body/Client';
import { Daybook } from '@/components/Daybook';
import { DaybookInner } from '@/components/Daybook/DaybookInner';
import { TestResult } from '@/components/Tests/TestResult';
import { TestHistory } from '@/components/Tests/TestHistory';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'profile', element: <Profile /> },
      { path: 'new-client', element: <NewClient /> },
      {
        path: '/:client',
        element: <Body />,
        children: [
          { index: true, element: <Client /> },
          { path: 'smer/:smer', element: <SmerInner /> },
          { path: 'smer', element: <Smer /> },

          { path: 'daybook', element: <Daybook /> },
          { path: 'daybook/:daybookId', element: <DaybookInner /> },

          { path: 'test/:type', element: <TestHistory /> },
          { path: 'test/:type/:id', element: <TestResult /> },
        ],
      },
    ],
  },
  {
    path: '/auth',
    element: <Auth />,
  },
]);
